import { render, staticRenderFns } from "./job-benefit-item.vue?vue&type=template&id=d9009532&scoped=true"
import script from "./job-benefit-item.vue?vue&type=script&lang=js"
export * from "./job-benefit-item.vue?vue&type=script&lang=js"
import style0 from "./job-benefit-item.vue?vue&type=style&index=0&id=d9009532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9009532",
  null
  
)

export default component.exports